import { useState, useEffect } from "react";
import { getCompanyTheme, saveCompanyTheme } from "@/services/api/themes";
import type { CompanyTheme } from "@/services/api/themes/types";

export function useCompanyTheme() {
  const [theme, setTheme] = useState<CompanyTheme | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadTheme();
  }, []);

  const loadTheme = async () => {
    setIsLoading(true);
    try {
      const loadedTheme = await getCompanyTheme();
      setTheme(loadedTheme);
    } catch (error) {
      console.error("Failed to load theme:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateTheme = async (newTheme: CompanyTheme) => {
    try {
      const savedTheme = await saveCompanyTheme(newTheme);
      setTheme(savedTheme);
      return savedTheme;
    } catch (error) {
      console.error("Failed to update theme:", error);
      throw error;
    }
  };

  return {
    theme,
    isLoading,
    updateTheme,
    reloadTheme: loadTheme,
  };
}

